import { AufnahmePunktDocument, BodenvegetationZeile } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";

export function schichtAnteilEval(schicht: 'b1'|'b2'|'str'|'kr1'|'kr2'|'m'): EvalFunc {
	return (bp: any, i?: number, key?: string) => {
		if (!bp.bodenvegetation?.aufnahme?.vegetationen) return undefined;
		const b = bp as AufnahmePunktDocument;
		const schichtVegetationen = b.bodenvegetation.aufnahme.vegetationen.filter((bv: BodenvegetationZeile) => bv.schicht === schicht);
		if (schichtVegetationen.length === 0) return undefined;
		
		return schichtVegetationen.reduce((sum: number, bv: BodenvegetationZeile) => {
			const anteil = parseFloat(bv.haeufigkeit);
			return sum + (!isNaN(anteil) ? anteil : 0);
		}, 0);
	};
}
